// extracted by mini-css-extract-plugin
module.exports = {"InformationPanel":"InformationPanel_InformationPanel__3tWOZ","header":"InformationPanel_header__2fByn","emptyActions":"InformationPanel_emptyActions__2wR6B"};